import cn from 'classnames';
import { FC, PropsWithChildren } from 'react';
import { Button, ButtonProps } from '../button/button';
import s from './extendable-block.module.css';

interface Props extends PropsWithChildren {
  button?: ButtonProps;
  label?: { className?: string } & PropsWithChildren;
  className?: string;
  onAdd?: () => void;
}

export const ExtendableBlock: FC<Props> = (props) => {
  const { children, button, label, onAdd, className } = props;
  const { className: buttonClassName, ...buttonProps } = button || {};

  return (
    <div className={cn(s.component, className)}>
      {label && <label {...label} />}
      {children}
      {button && <Button onClick={onAdd} className={cn(s.add, buttonClassName)} {...buttonProps} />}
    </div>
  );
};
